import Header from "./components/header";
import LeftView from "./components/leftView/leftView";
import RightView from "./components/rightView/rightView";
import AddOrEditOutOfOrderDrawer from "./drawers/AddOrEditOutOfOrderDrawer";
import { useState } from "react";
import { useSelector } from "react-redux";

const HousekeepingMainPage = () => {
   // 👉 drawer state just like in OutOfOrderRoomsPage
  const [oooVisible, setOooVisible]     = useState(false);
  const [oooEditingRecord, setOooRecord] = useState(null);
  const { hotelDetails } = useSelector((store) => store.login);
  const hotelId = hotelDetails?.id;
    const rooms = useSelector((s) => s.rooms.data);
  
  // Called when user clicks “Mark Out Of Order” in RightView
  const openOooForAdd = (selectedRoomIds) => {
    setOooRecord({ roomIds: selectedRoomIds });
    setOooVisible(true);
  };

  // If you ever want “Edit” from RoomsGrid (pass row to openOooForEdit)
  const openOooForEdit = (record) => {
    setOooRecord(record);
    setOooVisible(true);
  };

  const closeOooDrawer = () => {
    setOooVisible(false);
    setOooRecord(null);
  };

  return (
    <div className="bg-[#F2F4FC] mt-[3rem] w-full h-[93.7vh] overflow-hidden">
      <Header />
      <div className="flex">
        <LeftView />
        <RightView
        onOutOfOrderClick={openOooForAdd} 
        />
      </div>

       {/* and the drawer itself, exactly like your OutOfOrderRoomsPage */}
      <AddOrEditOutOfOrderDrawer
        visible={oooVisible}
        onClose={closeOooDrawer}
        hotelId={hotelId}
        rooms={rooms}
        mode={oooEditingRecord?.id ? "edit" : "add"}
        record={oooEditingRecord}
      />
    </div>
  );
};

export default HousekeepingMainPage;
